<template>
  <div
    v-if="searchActive"
    :class="{'is-open' : !collapsed}"
    class="header-site-search-form"
  >
    <form
      action="search-results"
      method="GET"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="input-group">
              <input
                id="header-search-query"
                ref="headerSearch"
                type="text"
                name="web-search"
                class="form-control header-search-input"
                placeholder="Search Website..."
                @keyup.esc="clearInput"
              >
              <span class="input-group-btn">
                <button
                  id="header-close-search"
                  class="btn btn-nav-search close-search"
                  type="button"
                  @click.prevent="triggerHideHeaderSearch"
                >
                  <font-awesome-icon
                    icon="times"
                    class="icon"
                  />
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="header-search-description">
              <div class="header-search-text">
                Hit enter to search or ESC to close
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import applogger from '@applogger'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
library.add(faTimes)

export default {
  data: function() {
    return {
      collapsed: true
    }
  },
  computed: {
    searchActive() {
      return this.$store.state.registry.getFeature('search')
    }
  },
  created: function() {
    this.$eventHub.$on('hideHeaderSearch', this.hideHeaderSearch)
    this.$eventHub.$on('showHeaderSearch', this.showHeaderSearch)
  },
  methods: {
    clearInput: function() {
      applogger.log('clearing input')
      this.$eventHub.$emit('hideHeaderSearch')
    },
    setFocus: function() {
      this.$refs.headerSearch.focus()
    },
    hideHeaderSearch: function() {
      this.collapsed = true
    },
    showHeaderSearch: function() {
      this.collapsed = false
      this.setFocus()
    },
    triggerHideHeaderSearch: function() {
      this.$eventHub.$emit('hideHeaderSearch')
    }
  }
}
</script>

<style lang="scss" scoped>

@import "~@scss/custom.scss";

//header search form and styling
// v.1

.header-site-search-form {
  top: 0;
  position: fixed;
  overflow-y: auto;
  max-height: 600px;
  -ms-transform: translateY(-100%);
  transform: translateY(-100%);
  width: 100%;
  z-index: 15;
  //transition all is a bit lazy
  @include transition (all .3s);
  background: var(--main-primary-dark);
  padding: 1.75em 0em;
  .input-group {
    input {
      color:$white;
      border: none;
      box-shadow: none;
      //background:rgba(255, 255, 255, 0.2);
      background-color:transparent;
      font-weight: 400;
      font-size: 1.5em;
      padding: 0em;
      &::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: $white;
      }
      &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: $white;
        opacity: 1;
      }
      &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color:$white;
        opacity: 1;
      }
      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color:$white;
      }
      &::-ms-input-placeholder {
        /* Microsoft Edge */
        color:$white;
      }

      &::placeholder {
        /* Most modern browsers support this now. */
        color:$white;
      }
    }
  }
  .input-group {
    padding: 1em;
      @if $enable-rounded {
      border-radius: 3px;
    }
  background: rgba(255, 255, 255, 0.2);
}
  .header-search-description {
    margin-top: 1em;
    color: #ffffff;
  }
  .header-search-text {
    text-align: center;
    font-size: 0.9em;
    opacity: 0.5;
  }
  &.is-open {
    visibility: visible;
    -ms-transform: translateY(0em);
    transform: translateY(0em);
  }
  .btn-nav-search {
    &.close-search {
      background: none;
      color: #ffffff;
      border: 2px solid;
      border-radius: 100%;
      width: 40px;
      height: 40px;
      text-align: center;
    }
  }
}

</style>
